import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { UserManagementFieldService } from './user-management-field.service';
import { User } from "./user";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { UserManagementService } from "./user-management.service";
import { DatePipe } from "@angular/common";
import { Subscription } from "rxjs/Subscription";
import { AppState } from "../../../app.service";
import { AlertService } from "../../../services";
import { ProgrammeService } from "../../../services/DataServices/programme.service";
import { FormControlBase } from "../../dynamic-form/form-control-base";
import { DynamicFormComponent } from "../../dynamic-form/dynamic-form.component";
import { AutoCompleteControl } from "../../dynamic-form/auto-complete-control";
import { RoleService } from "../role/role.service";
import { DropdownControl } from "../../dynamic-form/dropdown-control";
import { PermissionService } from "../../../services/SecurityServices/permission.service";
import { HttpClient } from "@angular/common/http";
import { PasswordControl } from '../../dynamic-form/password-control';

@Component({
    template: require('./user-management.html'),
    providers: [UserManagementFieldService, UserManagementService, DatePipe],
    styles: [require('../dynamic-form.css')]
})

export class UserManagementComponent implements OnInit {

    public fields: FormControlBase<any>[] = null;
    public disableForm: boolean = false;
    public user: User;
    public initialId: string;
    private busy: Subscription;

    @ViewChild(DynamicFormComponent)
    private dynamicFormComponent: DynamicFormComponent;

    constructor(
        private appState: AppState,
        private alertService: AlertService,
        private formControlService: UserManagementFieldService,
        private route: ActivatedRoute,
        private userManagementService: UserManagementService,
        private router: Router,
        private programmeService: ProgrammeService,
        private roleService: RoleService,
        private permissionService: PermissionService,
        private http: HttpClient
    ) {
    }

    private revertForm(): void {
        this.dynamicFormComponent.form.patchValue(this.user);
    }

    private submitForm(): void {
        let copy: any = Object.assign({
            userId: this.user.userId
        }, this.dynamicFormComponent.form.value);

        if (copy.password && copy.confirmPassword && copy.password != copy.confirmPassword) {
            this.alertService.error('Password and Confirm Password does not match.');
            return;
        }

        copy.loyaltySiteId = copy.loyaltySiteName ? copy.loyaltySiteName.key : null
        let self: UserManagementComponent = this;
        if (this.initialId == 'new') {
            copy.permissionsValue = 256;
            this.http.post<any>(UserManagementService.userUrl, copy).subscribe(() => {
                self.router.navigate(['admin/user-management']);
                self.alertService.success('User successfully created.');
            }, error => self.alertService.error(error.error) );
            return;
        }

        this.http.put<any>(UserManagementService.userUrl, copy).subscribe(() => {
            self.alertService.success('User succesfully updated.');
            self.router.navigate(['admin/user-management']);
        }, error => self.alertService.error(error.error));
    }

    ngOnInit() {
        let self: UserManagementComponent = this;
        this.route.paramMap
            .switchMap((params: ParamMap) => {
                self.initialId = params.get('id');
                let observable = this.userManagementService.getUser(params.get('id'));
                self.busy = observable.subscribe();
        
                return observable;
            })
            .subscribe((user: User) => {
                let isCustomer = user.permissionsValue == 32;
                if (isCustomer) {
                    self.router.navigate(['admin/customer-management/customer', user.userId]);
                    return;
                }
                self.user = user;
                self.disableForm = !self.permissionService.userHasPermission(self.initialId == 'new' ? 'Users_PostUser' : 'Users_UpdateUser');
                self.fields = self.formControlService.getFields();
                self.setLocationFieldOptions();
                self.setPasswordFieldOptions();
            });
    }

    private setLocationFieldOptions(): void {
        let locationField = this.fields.find(x => x.key == 'loyaltySiteName') as AutoCompleteControl;
        this.programmeService.getLoyaltySites().subscribe(data => {
            locationField.options = data.map(loyaltySite => {
                return { key: loyaltySite.LoyaltySiteId.toString(), value: loyaltySite.SiteName };
            });
            this.setLoyaltySiteName(locationField);
            this.setRoleFieldOptions();
        }, error => this.setRoleFieldOptions());
    }

    private setPasswordFieldOptions(): void {
        if (this.initialId !== 'new')
            return;
        let passwordField = this.fields.find(x => x.key == 'password') as PasswordControl;
        passwordField.required = true;
        let confirmPasswordField = this.fields.find(x => x.key == 'confirmPassword') as PasswordControl;
        confirmPasswordField.required = true;
    }

    private setRoleFieldOptions(): void {
        let roleField = this.fields.find(x => x.key == 'roleId') as DropdownControl;
        this.roleService.getAllRoles().subscribe(data => {
            roleField.options = data.map(role => {
                return { key: role.Id.toString(), value: role.RoleName };
            });
            this.dynamicFormComponent.form.patchValue(this.user);
        });
    }

    private setLoyaltySiteName(locationField: AutoCompleteControl) {
        let loyaltySite = locationField.options.find(x => x.key == this.user.loyaltySiteId);
        if (this.user.loyaltySiteId && loyaltySite) {
            this.user.loyaltySiteName = loyaltySite.value;
        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/user/user-management.component.ts